import { useIntl } from 'react-intl';

import Footer from '@/components/footer/FooterWrapper';
import Header from '@/components/header/Header';
import Layout from '@/components/layout/LayoutWrapper';
import heroMessages from '@/components/schools/Hero/messages';
import SchoolsLayout from '@/components/schools/SchoolsLayout';
import { useInitState } from '@/hooks/store';
import messages from '@/messages/messages';
import getUrl from '@/utils/getUrl';

const Schools = () => {
	const { formatMessage } = useIntl();

	useInitState();

	return (
		<Layout
			pageName="schools"
			title="Calm"
			customSeo={{
				title: formatMessage(messages.calmSchoolsTitle),
				primaryDescription: `${formatMessage(heroMessages.body)}.`,
				description: `${formatMessage(heroMessages.body)}.`,
				url: `${getUrl('www')}/schools`,
				imageUrl: `${getUrl('www')}/_n/images/social/schools-social.jpg`,
			}}
		>
			<Header isStatic isForSchools />
			<SchoolsLayout />
			<Footer />
		</Layout>
	);
};

export default Schools;
